<template>
  <AppFooter contact="help@umn.edu" />
</template>
<script setup lang="ts">
import { AppFooter } from "@umn-latis/cla-vue-template";
</script>
<style scoped></style>
